import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProductMinimalInterface } from 'src/app/model/products/product-minimal-interface';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { API_BASE_PRODUCTSERVICE, API_MAP } from 'src/environments/api';

@Component({
    selector: 'app-sitemap',
    templateUrl: './sitemap.component.html',
    styleUrls: ['./sitemap.component.scss'],
    standalone: false
})
export class SitemapComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['id', 'name', 'url'];
  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatSort) sort!: MatSort;
  products = [];

  constructor(
    public productService: ProductService,
    private cd: ChangeDetectorRef,
    protected http: HttpClient
  ) {
    const url: string = API_BASE_PRODUCTSERVICE + API_MAP['products']['MINIMAL'];
    this.http.get<ProductMinimalInterface[]>(url)
      .subscribe((success) => {
        const transformed = success.map(success => ({
          id: success.id,
          name: success.name,
          url: `/marktplatz/products/${success.id}`
        }));
        this.dataSource = new MatTableDataSource(transformed);
        this.cd.detectChanges();
      });
  }


  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
    } else {
      const interval = setInterval(() => {
        if (this.dataSource) {
          this.dataSource.sort = this.sort;
          this.cd.detectChanges();
          clearInterval(interval);
        }
      }, 100);
    }
  }


}
